import http from '@services/http'
import {
  IBetting,
  IBettingHistory,
  IBettingStorage,
  IBettingTotalCount,
  ICloseBetting,
  IDeleteBetting,
  IMyActivity,
  IMyActivityHistory,
  IMyActivityRewardHistory,
  IMyCheerForTeam,
  ISpecialBetting,
} from '@protocol/my'
import { IUserPickMine, IUserPickMyLikedList } from '@protocol/user-pick'

export default {
  getMyBettings(data: IBetting.Params): Promise<IBetting.Schema> {
    return http.post('my/betting', data || {})
  },

  getMySpecialBettings(data: ISpecialBetting.Params): Promise<ISpecialBetting.Schema> {
    return http.post('my/specialBetting', data || {})
  },

  getSharedBettingHistories(data: IBetting.Params): Promise<IBetting.Schema> {
    return http.post('my/sharedBettingHistories', data || {})
  },

  saveBettingHistory(data: IBettingHistory.Params): Promise<IBettingHistory.Schema> {
    return http.post('my/saveBettingHistory', data || {})
  },

  storageBettingHistory(data: IBettingStorage.Params): Promise<IBettingStorage.Schema> {
    return http.post('my/storageBettingHistory', data || {})
  },

  deleteBettingHistory(data: IDeleteBetting.Params): Promise<IDeleteBetting.Schema> {
    return http.post('my/deleteBettingHistory', data || {})
  },

  closeBettingHistory(data: ICloseBetting.Params): Promise<ICloseBetting.Schema> {
    return http.post('my/closeBettingHistory', data || {})
  },

  getMyBettingTotalCount(data: IBettingTotalCount.Params): Promise<IBettingTotalCount.Schema> {
    return http.post('my/bettingTotalCount', data || {})
  },

  /**
   * 내가 작성한 분석글 목록
   * @param data
   */
  getUserPicks(data: IUserPickMine.Params): Promise<IUserPickMine.Schema> {
    return http.get('my/userPicks', data)
  },

  /**
   * 내가 좋아요한 분석글 목록
   * @param data
   */
  getUserPickLikedList(data: IUserPickMyLikedList.Params): Promise<IUserPickMyLikedList.Schema> {
    return http.get('my/userPickLikedList', data)
  },

  async fetchMyActivity(data: IMyActivity.Params): Promise<IMyActivity.Schema> {
    return http.get('my/activity', {})
  },

  async fetchMyActivityHistory(data: IMyActivityHistory.Params): Promise<IMyActivityHistory.Schema> {
    return http.get('my/activityHistory', data)
  },

  async fetchMyActivityRewardHistory(data: IMyActivityRewardHistory.Params): Promise<IMyActivityRewardHistory.Schema> {
    return http.get('my/activityRewardHistory', data)
  },

  async fetchMyCheerForTeamList(params: IMyCheerForTeam.Params): Promise<IMyCheerForTeam.Schema> {
    return http.get('my/cheerForTeamList', params)
  },
}
